import { createApi } from '@reduxjs/toolkit/dist/query/react'

import { pwsClient } from 'src/apollo-clients'
import axiosBaseQuery from './axiosBaseQuery'
import graphQLBaseQuery from './graphQLBaseQuery'
import { Tags } from './types'

// We create an empty API here to allow for code-splitting.
// Individual endpoints are created in the `dataAccess` files of modules.
export const pwsApi = createApi({
  // The axiosBaseQuery pulls the account ID automatically making the full base URL `/pws/rest/accounts/${id}`
  baseQuery: axiosBaseQuery({ baseUrl: `/pws/rest/accounts/` }),
  reducerPath: 'pwsApi',
  tagTypes: [Tags.Events, Tags.Programs, Tags.Locations, Tags.Activities],
  endpoints: () => ({})
})

export const pwsApiV2 = createApi({
  baseQuery: axiosBaseQuery({ baseUrl: `/pws/accounts/` }),
  reducerPath: 'pwsApiV2',
  tagTypes: [Tags.WorkOrders, Tags.Locations],
  endpoints: () => ({})
})

export const pwsApiV3 = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl: `/pws/rest/`,
    skipAccount: true
  }),
  reducerPath: 'pwsApiV3',
  tagTypes: [Tags.AccountResources],
  endpoints: () => ({})
})

export const pwsGQL = createApi({
  baseQuery: graphQLBaseQuery({ client: pwsClient }),
  reducerPath: 'pwsGQL',
  tagTypes: [Tags.Activities, Tags.Accounts],
  endpoints: () => ({})
})

export default pwsApi
